import { createFileRoute } from '@tanstack/react-router';
import { BusinessLandingPage } from '#src/pages/BusinessLandingPage/index.ts';

export const Route = createFileRoute('/{-$locale}/business')({
  component: RouteComponent,
  ssr: true
});

function RouteComponent() {
  return <BusinessLandingPage />;
}
